import { render } from "./TransactionTypePayment.vue?vue&type=template&id=630d47d7&scoped=true"
import script from "./TransactionTypePayment.vue?vue&type=script&lang=js"
export * from "./TransactionTypePayment.vue?vue&type=script&lang=js"

import "./TransactionTypePayment.vue?vue&type=style&index=0&id=630d47d7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-630d47d7"

export default script